import { useEffect } from "react";

export function usePageTitle(pageTitle?: string): void {
  useEffect(() => {
    const previousTitle = document.title;

    if (pageTitle && pageTitle.trim() !== "") {
      document.title = `${pageTitle} | Microsoft Commercial Partner Incentives Guide`;
    } else {
      document.title = "Microsoft Commercial Partner Incentives Guide";
    }

    return (): void => {
      document.title = previousTitle;
    };
  }, [pageTitle]);
}
